export const FETCH_DATA_SOURCE_CONDITIONS = "FETCH_DATA_SOURCE_CONDITIONS";
export const FETCH_DATA_SOURCE_CONDITIONS_SUCCESS =
  "FETCH_DATA_SOURCE_CONDITIONS_SUCCESS";
export const FETCH_DATA_SOURCE_CONDITIONS_FAILED =
  "FETCH_DATA_SOURCE_CONDITIONS_FAILED";
